import { render, staticRenderFns } from "./FormInputTextarea.vue?vue&type=template&id=689783c5&"
import script from "./FormInputTextarea.vue?vue&type=script&lang=js&"
export * from "./FormInputTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('689783c5')) {
      api.createRecord('689783c5', component.options)
    } else {
      api.reload('689783c5', component.options)
    }
    module.hot.accept("./FormInputTextarea.vue?vue&type=template&id=689783c5&", function () {
      api.rerender('689783c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/FormInputTextarea.vue"
export default component.exports